import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/index'),
      redirect: 'main',
      children: [
        {
          path: 'main',
          name: 'main',
          component: () => import('@/pages/homePage/index')
        },
        {
          path: 'gis',
          name: 'gis',
          component: () => import('@/pages/gis/gis')
        },
        {
          path: 'program',
          name: 'program',
          component: () => import('@/pages/table/program')
        },
        {
          path: 'environment',
          name: 'environment',
          component: () => import('@/pages/table/environment')
        },
        {
          path: 'chargingPle',
          name: 'chargingPle',
          component: () => import('@/pages/table/chargingPle')
        },
        {
          path: 'switchSettings/singleLamp',
          name: 'singleLamp',
          component: () => import('@/pages/switchSettings/singleLamp')
        },
        {
          path: 'equipmentManagement',
          name: 'equipmentManagement',
          component: () => import('@/pages/equipmentManagement/index')
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js